import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            w: '100%',

            '.swiper-wrapper': {
                alignItems: 'stretch',
                mb: remCalc(34),
            },
            '.swiper-slide': {
                h: 'unset !important',
            },
            '.swiper-button-disabled': {
                display: 'none',
            },
        },
        container: {
            maxW: {xl: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
        },
        chevronIcon: {
            w: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            h: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            top: {base: remCalc(166), md: remCalc(84), lg: remCalc(113), xl: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            pt: {base: remCalc(16), md: remCalc(40)},
            pb: {base: remCalc(16), md: remCalc(24)},
            w: '100%',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            fontWeight: 'normal',
            pb: {base: remCalc(16), md: remCalc(40)},
        },
        emptyTileContainer: {
            minH: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
        tilecontainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
            mb: remCalc(24),
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        tile: {
            w: '100%',
            h: '100%',
            gap: remCalc(24),
            justifyContent: {base: 'flex-start', md: 'space-between'},
            flexDirection: 'column',
        },
        tiletextbox: {
            gap: remCalc(24),
            justifyContent: 'flex-start',
        },
        tileimage: {
            w: '100%',
            maxW: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            minW: {base: remCalc(332), md: 'unset'},
            alignSelf: 'center',
        },
        tiletitle: {
            textStyle: 'head-small',
            fontWeight: 'medium',
        },
        tilebodycopy: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        features: {
            listStyleType: 'none',
        },
        feature: {
            py: remCalc(20),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        cta: {
            w: '100%',
            textDecoration: 'none !important',
            alignSelf: 'center',
            whiteSpace: 'unset',
        },
    },
}
